import { render, staticRenderFns } from "./AreaToggle.vue?vue&type=template&id=060eee22&"
import script from "./AreaToggle.vue?vue&type=script&lang=js&"
export * from "./AreaToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports